<script>
    import { onMount } from "svelte";
    export let data = null
    export let labels = null
    export let title = null
    export let titleData = null

    onMount(async () => {
        if (data && Canvas) {
            data.forEach((item,idx) => {
                ColorR.push(new Array())
                item.forEach(element => {
                    ColorR[idx].push(dynamicColors())
                })
                DataSets.push({
                    label: titleData[idx],
                    data: item,
                    backgroundColor: ColorR[idx],
                    borderColor: "rgba(255, 159, 64, 1)",
                    borderWidth: 1,
                })
            })
            renderChart()
        }
    });

    let Canvas = null
    let ColorR = []
    let DataSets = []

    var dynamicColors = function() {
        var r = Math.floor(Math.random() * 255);
        var g = Math.floor(Math.random() * 255);
        var b = Math.floor(Math.random() * 255);
        return `rgba(${r},${g},${b},${0.2})`;
    };

    

    function renderChart() {
        var ctx = Canvas.getContext("2d");
        var chart = new Chart(ctx, {
            type: "bar",
            data: {
                labels: labels,
                datasets : DataSets
            },
            options: {
                scales: {
                    y: {
                        beginAtZero: true,
                    },
                },
            },
        });
    }
</script>

<div class="chart-container">
    <canvas bind:this={Canvas} style="padding: 20px;" />
</div>

<style>
    .chart-container {
        position: relative;
        margin: auto;
        /* height: 50vh;
        width: 50vh; */
    }
</style>